module.exports = __webpack_public_path__ + "img/creators-illustration.1b3cfdc5.jpg";